module.exports = __webpack_public_path__ + "img/home_point_double.88fcfbb8.png";